export function buildTellentAssistantHeaders(
  token: string | null,
  actor: string | null,
  devPlayground: boolean,
): Record<string, string> {
  const headers: Record<string, string> = {};
  if (devPlayground) headers['x-mastra-dev-playground'] = 'true';
  if (token) headers['Authorization'] = token;
  if (actor) headers['x-ts-actor'] = actor;
  return headers;
}

export const AGENT_ID = 'tellentAssistant';
